import { Api } from "./api"

const PATH = 'country'
const ENDPOINTS = {
    Liste: 'liste',
    Store: 'store',
    Show: 'show',
    Update: 'update',
    Activate: 'activate',
    Deactivate: 'deactivate',
    BulkActivate: 'bulk-activate',
    BulkDeactivate: 'bulk-deactivate',
    Delete: 'delete',
}

const getCountries = (params = {}, signal) => {
    const query = new URLSearchParams(params).toString()
    return Api.get(`${PATH}/${ENDPOINTS.Liste}${query ? `?${query}` : ''}`, signal)
}

const getCountryDetails = (id, signal) => {
    return Api.get(`${PATH}/${ENDPOINTS.Show}/${id}`, signal)
}

const storeCountry = (payload, signal) => {
    return Api.post(`${PATH}/${ENDPOINTS.Store}`, payload, signal)
}

const updateCountry = (id, payload, signal) => {
    return Api.post(`${PATH}/${ENDPOINTS.Update}/${id}`, payload, signal)
}

const activateCountry = (id, signal) => {
    return Api.post(`${PATH}/${ENDPOINTS.Activate}/${id}`, '', signal)
}

const deactivateCountry = (id, signal) => {
    return Api.post(`${PATH}/${ENDPOINTS.Deactivate}/${id}`, '', signal)
}

const deleteCountry = (id, signal) => {
    return Api.erase(`${PATH}/${ENDPOINTS.Delete}/${id}`, signal)
}

const bulkActivateCountries = (ids, signal) => {
    return Api.post(`${PATH}/${ENDPOINTS.BulkActivate}`, JSON.stringify({ ids }), signal)
}

const bulkDeactivateCountries = (ids, signal) => {
    return Api.post(`${PATH}/${ENDPOINTS.BulkDeactivate}`, JSON.stringify({ ids }), signal)
}

export const CountryApi = {
    getCountries,
    getCountryDetails,
    storeCountry,
    updateCountry,
    activateCountry,
    deactivateCountry,
    bulkActivateCountries,
    bulkDeactivateCountries,
    deleteCountry,
}
